import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import BlogContent from "../../components/blog/BlogContent";
import BlogSidebar from "../../components/blog/BlogSidebar";
import Loader from "../../components/common/Loader";
import { getBlog, listBlogs } from "../../services/blogService";
import { formatISTDateLong } from "../../utils/dateTime";
import { setPageMeta } from "../../utils/seo";

const BlogDetailsPage = () => {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  const [related, setRelated] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    setBlog(null);
    setError("");
    getBlog(slug)
      .then((data) => {
        setBlog(data);
        setPageMeta({
          title: `${data.title} | CYNOS Blog`,
          description: data.excerpt,
        });
        return listBlogs({ category: data.category });
      })
      .then((items) => setRelated(items.filter((item) => item.slug !== slug).slice(0, 4)))
      .catch(() => setError("Blog post not found."));
  }, [slug]);

  if (error) return <main className="pt-32 px-6 text-center font-mono text-cynos-red uppercase">{error}</main>;
  if (!blog) return <main className="pt-32 px-6"><Loader label="Loading story..." /></main>;

  return (
    <main className="pt-24 px-4 md:px-8 lg:px-12 pb-24" data-testid="blog-detail-page">
      <article>
        <div className="max-w-4xl">
          <Link to="/blog" className="font-mono text-xs uppercase tracking-[0.2em] text-cynos-red hover:text-white">Back to Blog</Link>
          <h1 className="mt-5 font-anton text-5xl md:text-8xl uppercase leading-none">{blog.title}</h1>
          <p className="mt-5 max-w-2xl text-zinc-400">{blog.excerpt}</p>
          <div className="mt-6 font-mono text-xs uppercase tracking-[0.2em] text-zinc-500">
            By {blog.author || "CYNOS"} - {formatISTDateLong(blog.created_at)}{blog.category ? ` - ${blog.category}` : ""}
          </div>
        </div>

        {blog.image && (
          <img src={blog.image} alt={blog.title} className="mt-10 aspect-[16/8] w-full object-cover border border-white/10 bg-cynos-surface" />
        )}

        <div className="mt-12 grid gap-10 lg:grid-cols-[1fr_320px]">
          <BlogContent html={blog.content} />
          <BlogSidebar blogs={related} />
        </div>
      </article>
    </main>
  );
};

export default BlogDetailsPage;
